import { render, staticRenderFns } from "./ProfilePortfolio.vue?vue&type=template&id=15a35551&"
import script from "./ProfilePortfolio.vue?vue&type=script&lang=js&"
export * from "./ProfilePortfolio.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePortfolio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports